import { Battery, Bluetooth, Sparkles, Headphones, Brain, Feather, ShieldCheck, MessageSquare, Activity, Radio } from "lucide-react";

const FEATURES = [
    {
        icon: Feather,
        title: "Ultra-slim SlimRIC design",
        body: "Engineered as the slimmest RIC hearing aid Signia has ever made — sits discreetly behind the ear, even comfortable with glasses. Available in 7 colours from Black Gloss to Cosmic Blue and Rose Gold.",
        size: "lg",
    },
    {
        icon: Brain,
        title: "RealTime Conversation Enhancement",
        body: "The flagship feature of Signia Integrated Xperience (IX) — AI identifies the active speaker in a group and steers amplification to them in real time. Clinically shown to outperform 4 top competitors in noisy groups.",
    },
    {
        icon: Battery,
        title: "All-day rechargeable + wireless case",
        body: "17–20 hours per charge including streaming. The pocket-sized Styletto wireless charger adds up to 5 additional full charges before it needs a power outlet.",
    },
    {
        icon: Bluetooth,
        title: "iPhone + Android + LE Audio ready",
        body: "Full Bluetooth streaming to iPhone (MFi) and Android (ASHA). Hands-free calling on iPhone. Ready for the future of Bluetooth LE Audio via firmware update.",
    },
    {
        icon: MessageSquare,
        title: "Signia Assistant AI",
        body: "An in-app AI companion that offers immediate support whenever you want to customize your sound — inspired by neural-network problem-solving.",
    },
    {
        icon: Activity,
        title: "My WellBeing tracking",
        body: "Track daily steps and activity — the hearing aid's built-in motion sensors send data to the Signia app so you stay healthy in mind and body.",
    },
    {
        icon: Radio,
        title: "TV Sound + StreamLine Mic",
        body: "Optional accessories that add Dolby Digital-quality TV streaming and a remote lapel microphone for restaurant, meeting or podium scenarios.",
    },
    {
        icon: ShieldCheck,
        title: "Up to 4-year Signia India warranty",
        body: "3-year Signia India warranty on 1IX/2IX/3IX, extended to 4-year on premium 5IX/7IX — plus lifetime service via HearClear clinics.",
    },
];

export default function FeatureGrid() {
    return (
        <section className="section bg-[#f8f9fa]" data-testid="feature-grid">
            <div className="container-x">
                <div className="max-w-[760px]">
                    <p className="eyebrow flex items-center gap-2"><Sparkles size={12} /> The full Styletto IX ecosystem</p>
                    <h2 className="font-serif text-[40px] md:text-[56px] leading-[1.04] mt-3 text-[#1a1a1a]">
                        Designed for modern hearing.
                        <br />
                        <span className="italic text-[#003E4D]">Powered by Signia Integrated Xperience.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-12">
                    {FEATURES.map((f, i) => (
                        <article
                            key={i}
                            className={`card-premium p-7 md:p-9 ${f.size === "lg" ? "md:col-span-2 md:row-span-1" : ""}`}
                            data-testid={`feature-${i}`}
                        >
                            <span className="w-11 h-11 rounded-full bg-[#003E4D]/[0.07] flex items-center justify-center text-[#003E4D]">
                                <f.icon size={18} />
                            </span>
                            <h3 className="font-serif text-[24px] md:text-[28px] mt-5 leading-tight text-[#1a1a1a]">
                                {f.title}
                            </h3>
                            <p className="mt-3 text-[15px] text-[#4a5568] leading-relaxed">{f.body}</p>
                        </article>
                    ))}
                </div>

                {/* Retain Headphones icon reference to satisfy import (may reintroduce later) */}
                <Headphones size={0} className="hidden" />
            </div>
        </section>
    );
}
